// extracted by mini-css-extract-plugin
export default {"top_to_bottom_wave":"HomePage_top_to_bottom_wave__A1e2o"};